module.exports = __webpack_public_path__ + "img/Edit-assumptions.2ffd33e5.svg";